

angular.module('iqxCore')
.directive('iqxClickoutside', function($document, $parse, $timeout){
	return {
		restrict: 'A',
		priority: 1,
		scope: {
			iqxClickoutside: '&'
		},
		link: function(scope, element, attr) {
			// postpone linking to next digest to allow for unique id generation
			$timeout(function() {

				function isSameOrDescendant(parent, child) {
						if(!document.body.contains(child)){
							return true
						}
						if(parent.contains(child)){
							return true
						}
						return false
				}

				function eventHandler(e) {
					// if there is no click target, no point going on
					if (!e || !e.target) {
						return
					}

					if(!isSameOrDescendant(element[0], e.target)){
						scope.iqxClickoutside()
					}
				}

				// if the devices has a touchscreen, listen for this event
				if (_hasTouch()) {
						$document.on('touchstart', function () {
							eventHandler
						})
				}

				// still listen for the click event even if there is touch to cater for touchscreen laptops
				$document.on('click', eventHandler)

				// when the scope is destroyed, clean up the documents event handlers as we don't want it hanging around
				scope.$on('$destroy', function() {
						if (_hasTouch()) {
								$document.off('touchstart', eventHandler)
						}

						$document.off('click', eventHandler)
				})

				function _hasTouch() {
						// works on most browsers, IE10/11 and Surface
						return 'ontouchstart' in window || navigator.maxTouchPoints
				}
			})
		}
	}
})